export enum TypeSearchHeader {
    SEARCH = 0,
    QUERIES = 1,
}
